import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormControlProps,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
  Typography,
} from '@mui/material';
import { Row } from '.';

interface DropdownMenuProps extends React.PropsWithChildren {
  options: any[];
  label?: string;
  variant?: FormControlProps['variant'];
  selected?: string | null;
  innerRef?: React.RefObject<any>;
  callback?: (value: string) => void;
  inputStyles?: React.CSSProperties;
  formControlProps?: FormControlProps;
  selectProps?: SelectProps<any>;
  icon?: React.ReactNode;
  disabled?: boolean;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  options,
  label,
  variant = 'standard',
  selected: selectedParam,
  innerRef,
  callback,
  inputStyles,
  formControlProps,
  selectProps = {},
  icon,
  disabled = false,
}) => {
  const [selected, setSelected] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selectedParam) {
      setSelected(selectedParam);
    }
  }, [selectedParam]);

  const handleChange = (event: SelectChangeEvent) => {
    setSelected(event.target.value);
    if (callback) callback(event.target.value);
  };
  const handleOpen = () => !disabled && setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Row
      style={{ alignItems: 'center', cursor: disabled ? 'default' : 'pointer' }}
      onClick={handleOpen}>
      {label && (
        <Typography variant='h2' color='info.main'>
          {label}
        </Typography>
      )}
      <FormControl variant={variant} sx={{ minWidth: 120, ...inputStyles }} {...formControlProps}>
        <Select
          ref={innerRef}
          labelId='label'
          id='id'
          value={selected}
          onChange={handleChange}
          open={open}
          onOpen={handleOpen}
          onClose={handleClose}
          startAdornment={
            icon && (
              <InputAdornment
                position='start'
                style={{
                  cursor: disabled ? 'default' : 'pointer',
                  opacity: disabled ? 0.5 : 1,
                }}>
                {icon}
              </InputAdornment>
            )
          }
          disabled={disabled}
          MenuProps={{
            ...selectProps.MenuProps,
            onClick: e => e.stopPropagation(),
          }}
          {...selectProps}>
          {options.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Row>
  );
};

export default DropdownMenu;
